export default __webpack_public_path__ + "static/media/aditivos.f1773c67.png";